import { TAB_IDS } from '../constants';

export const SUPPORTED_TAB_IDS = [
  TAB_IDS.FEED,
  TAB_IDS.TREATMENT_OPTIONS,
  TAB_IDS.SUPPORT_PROGRAMS,
  TAB_IDS.SYMPTOM_CARE,
  TAB_IDS.ARTICLES,
  TAB_IDS.SPEAK_WITH_TINA,
];
